import React from 'react';
export function QuoteSection() {
  return <section className="w-full bg-cream py-20 sm:py-28" aria-label="Palabras de Cenia Badillo" data-id="element-90" data-mp="2qpqedy6sb2oa">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-91" data-mp="3uwqhzsn24gzr">
        <svg className="mx-auto h-7 w-7 text-gold" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} aria-hidden="true" data-id="element-92" data-mp="3gyjqcu8pbd8j">
          <path d="M9.5 6.2C6.9 7.8 5.2 10.4 5.2 13.6c0 2.6 1.6 4.3 3.7 4.3 1.9 0 3.3-1.4 3.3-3.2 0-1.8-1.2-3-2.9-3-.3 0-.5 0-.7.1" data-id="element-93" data-mp="376w3l6n3akde" />
          <path d="M18.5 6.2c-2.6 1.6-4.3 4.2-4.3 7.4 0 2.6 1.6 4.3 3.7 4.3 1.9 0 3.3-1.4 3.3-3.2 0-1.8-1.2-3-2.9-3-.3 0-.5 0-.7.1" data-id="element-94" data-mp="3c0qm46qyktaw" />
        </svg>
        <blockquote className="mt-8" data-id="element-95" data-mp="3282s1jrd53fv">
          <p className="font-serif text-3xl font-light italic leading-[1.25] text-navy sm:text-4xl lg:text-5xl" data-id="element-96" data-mp="32943vqg7dtyn">
            “Casa es patrimonio, dinero para el futuro, pero sobre todo significa que tú tomas las
            riendas de tu vida.”
          </p>
          <div className="mx-auto mt-10 h-px w-16 bg-gold" aria-hidden="true" data-id="element-97" data-mp="gdfv354ih3uf" />
          <footer className="mt-6 font-sans text-[11px] font-semibold uppercase tracking-[0.32em] text-gold" data-id="element-98" data-mp="bfebmj36b2if">
            — Cenia Badillo, Realtor
          </footer>
        </blockquote>
      </div>
    </section>;
}